module.exports = __webpack_public_path__ + "static/media/doc.6f75f4ce.svg";